// import prixAchatHT from '@/prixAchatHT.vue'
import {createStore}  from 'vuex'




 const store= createStore ({
    state(){
        return {
           count:1,
           etablissement:'DEPO',
           token_y2:'',
           date:'',
           barcodeFinded:'',
           articles: {},
           articlesBackUp: {},
           stockArticles:{},
           clients:[],
           waiting:false,
           marques:[],
           rayons:[],
           familles:[],
           sousFamilles:[],
           themes:[],
           dialogprixAchatHT:false,
           scanBarCode:'',
           countId:0,
           cab:0,
           numeroBon:1,
           signature:{exist:false,link:''},
           photoLinks:{exist:false,link:[],id:[]},
           articlesFripe:[],
           listeReceptions:{receptions:[],data:[]},
           codeFournisseur:{updated:false,code:'951263'},
           user:{name:"Marwen",username:"m.benhamada",password:"marwen/001",language:"fr",etablissement:"DEPO",groupe:"A",email:"m.benhamada@edisac.com",statut:'connected',token:''},
           itemsSaisons:['E24','E25','E26','E27','E28','E29','H24','H25','H26','H27','H28','H29'],
           itemsEtablissemnt:{
              etabDEPO:{filliale:'DEPOT', etabliss:['DEPO','DWEB']},
              etabAD:{filliale:'AD', etabliss:['DEFEC','DEPAD','LITIG','NEGO','PHOTO','RECEP','TRANS','NGEXT']},
              etabReflex:{filliale:'Reflex', etabliss:['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']},
              etabEtrier:{filliale:'Etrier', etabliss:['CA24','VX05','PR25']},
              etabEdiBE:{filliale:'Edisac Belgique', etabliss:['BR08','NP19','GE22','OO10']},
              etabEdiFrNord:{filliale:'Edisac Nord', etabliss:['DK03','MN01','EN11','FT04','LI02','RO06',]},
              etabEdiPDC:{filliale:'Edisac PDC', etabliss:['AR09','CO18','HB21']},
              etabLc:{filliale:'Lonchamp', etabliss:['LO07']}
           },
           itemsPoles:[{code:'ACC' , libelle :'Pôle Accessoires'},	{code:'BAG' , libelle :'Pôle Bagages'},	{code:'BUS' , libelle :'Pôle Business'},	{code:'CHA' , libelle :'Pôle Chaussures'},	{code:'EMB' , libelle :'Pôle Emballages'},	{code:'LIF' , libelle :'Pôle Lifestyle'},	{code:'LUX' , libelle :'Pôle Luxe'},	{code:'MAR' , libelle :'Pôle Maroquinerie'},	{code:'MIN' , libelle :'Pôle Miniprix'},	{code:'NOS' , libelle :'Pôle Marque Propres'},	{code:'SCO' , libelle :'Pôle Scolaire'},	{code:'SEC' , libelle :'Pôle Second Life'},	{code:'SER' , libelle :'Pôle Services'},	{code:'VET' , libelle :'Pôle Vêtements'}],
           itemsAcheteurs:[{code:'ALD' , libelle :'ALICE'},	{code:'ARD' , libelle :'ARNAUD'},	{code:'ATR' , libelle :'AUTRE'},	{code:'AUT' , libelle :'AURELIE'},	{code:'EML' , libelle :'EMMA'},	{code:'JMC' , libelle :'JULIETTE'},	{code:'JVP' , libelle :'JASPER'},	{code:'LVK' , libelle :'LISA'},	{code:'MDD' , libelle :'MAUD'},	{code:'NOP' , libelle :'NOEMIE'},	{code:'SHP' , libelle :'SHIRLEY'},	{code:'VAS' , libelle :'VANESSA'}],
           isChangedCol:{ficheArticle:false,prixBase:false,promo:false,repart:false},
           itemColors:['AA-BLACK',	'AB-BLUE',	'AC-GREY',	'AD-MULTICOLOR',	'AE-WHITE',	'AF-BEIGE',	'AG-TAUPE',	'AH-CAMEL',	'AI-BROWN',	'AJ-RED',	'AK-ORANGE',	'AL-PINK',	'AM-PURPLE',	'AN-GREEN',	'AO-YELLOW'],
            // itemColors:[{title:'AA-BLACK',color:'black'},	{title:'AB-BLUE',color:'blue'},{title:'AC-GREY',color:'grey'}]
           component:'',
           frep:{
            title:{
                libelle:'BON DE COMMANDE',
                saison:'SPRING - SUMMER 2026',
                dateModif:'2025-09-25'
            },
            fournisseur:{
                date:'2025-10-01',
                nomClient:'Test',
                codeClient:'code_test',
                agent:'agent_test',
                codeAgent:'code_agent',
                libCommande:'testcommande',
                type_commande:'MEP',
                etablissement:'NEGO'
            },
            client:{
                enseigne:'enseigne',
                raisonSociale:'test',
                tvaSiret:'TVA_TEST',
                dateLivraison:'2025-10-15',
                adresseLiv:'Adresse liv',
                adresseFac:'Adresse Fac',
                contact:'contact_test',
                email:'emailtest',
                telephone:'0769',
                siteweb:'site',
                remarque:'Remarque'
            },
            fraisPort:20,
            remisePied1:10,
            remisePied2:0,
            articles:{
 
            },
            signature:{exist:false,link:'',file:''}
          },
          mode:'',
          dateLivraisons:["20251013"],
          marque:"731",
          ip:'',
          subTypeMap : {
            'promo': [],
            'stock': ['Stock'],
            'collec': [],
            'couleur': [],
            'taille': []
          },
          progressDialog: false,
          transfert :{
            etablissementOrigine: '',
            etablissementDestinataire: '',
            createur: '',
            lignes: [
              {
                  designation: '',
                  reference: '',
                  couleur: '',
                  taille: '',
                  codeBarre: '',
                  prixTTC: 0.0,
                  qte: 1,
                  totalLigne: 0.0
              }
            ]
          },
          composition:[],
          compositions:[],
          currentPage : 1,
          itemsPerPage : 100,
          typeMarchandise:[
            {code:"MNA",libelle:"National"},
            {code:"MEU",libelle:"Europe"},
            {code:"MIN",libelle:"Internationale"},
            {code:"IMG",libelle:"Image"}
            ]
          ,
          countries:[],
          designCompl:{
            "J":[
                {"code":"J1","fr":"1 compartiment","nl":"1 compartiment","en":"1-compartment #"},
                {"code":"J2","fr":"1 compartiment + PC 13\"","nl":"1 compartiment met 13\" laptopvak","en":"1-compartment # with 13\" laptop sleeve"},
                {"code":"J3","fr":"1 compartiment + PC 14\"","nl":"1 compartiment met 14\" laptopvak","en":"1-compartment # with 14\" laptop sleeve"},
                {"code":"J4","fr":"1 compartiment + PC 15\"","nl":"1 compartiment met 15\" laptopvak","en":"1-compartment # with 15\" laptop sleeve"},
                {"code":"J5","fr":"1 compartiment + PC 16\"","nl":"1 compartiment met 16\" laptopvak","en":"1-compartment # with 16\" laptop sleeve"},
                {"code":"J6","fr":"1 compartiment + PC 17\"","nl":"1 compartiment met 17\" laptopvak","en":"1-compartment # with 17\" laptop sleeve"},
                {"code":"J7","fr":"2 compartiments","nl":"2 compartimenten","en":"2-compartment #"},
                {"code":"J8","fr":"2 compartiments + PC 13\"","nl":"2 compartimenten met 13\" laptopvak","en":"2-compartment # with 13\" laptop sleeve"},
                {"code":"J9","fr":"2 compartiments + PC 14\"","nl":"2 compartimenten met 14\" laptopvak","en":"2-compartment # with 14\" laptop sleeve"},
                {"code":"J10","fr":"2 compartiments + PC 15\"","nl":"2 compartimenten met 15\" laptopvak","en":"2-compartment # with 15\" laptop sleeve"},
                {"code":"J11","fr":"2 compartiments + PC 16\"","nl":"2 compartimenten met 16\" laptopvak","en":"2-compartment # with 16\" laptop sleeve"},
                {"code":"J12","fr":"2 compartiments + PC 17\"","nl":"2 compartimenten met 17\" laptopvak","en":"2-compartment # with 17\" laptop sleeve"},
                {"code":"J13","fr":"3 compartiments","nl":"3 compartimenten","en":"3-compartment #"},
                {"code":"J14","fr":"3 compartiments + PC 13\"","nl":"3 compartimenten met 13\" laptopvak","en":"3-compartment # with 13\" laptop sleeve"},
                {"code":"J15","fr":"3 compartiments + PC 14\"","nl":"3 compartimenten met 14\" laptopvak","en":"3-compartment # with 14\" laptop sleeve"},
                {"code":"J16","fr":"3 compartiments + PC 15\"","nl":"3 compartimenten met 15\" laptopvak","en":"3-compartment # with 15\" laptop sleeve"},
                {"code":"J17","fr":"3 compartiments + PC 16\"","nl":"3 compartimenten met 16\" laptopvak","en":"3-compartment # with 16\" laptop sleeve"},
                {"code":"J18","fr":"3 compartiments + PC 17\"","nl":"3 compartimenten met 17\" laptopvak","en":"3-compartment # with 17\" laptop sleeve"},
                {"code":"J19","fr":"A4","nl":"A4 formaat","en":"A4 size #"},
                {"code":"J20","fr":"A4 + PC 13\"","nl":"A4 formaat met 13\" laptopvak","en":"A4 size # with 13\" laptop sleeve"},
                {"code":"J21","fr":"A4 + PC 14\"","nl":"A4 formaat met 14\" laptopvak","en":"A4 size # with 14\" laptop sleeve"},
                {"code":"J22","fr":"A4 + PC 15\"","nl":"A4 formaat met 15\" laptopvak","en":"A4 size # with 15\" laptop sleeve"},
                {"code":"J23","fr":"A4 + PC 16\"","nl":"A4 formaat met 16\" laptopvak","en":"A4 size # with 16\" laptop sleeve"},
                {"code":"J24","fr":"A4 + PC 17\"","nl":"A4 formaat met 17\" laptopvak","en":"A4 size # with 17\" laptop sleeve"},
                {"code":"J25","fr":"ajustable","nl":"verstelbare #","en":"adjustable #"},
                {"code":"J26","fr":"amovible","nl":"afneembare #","en":"detachable #"},
                {"code":"J27","fr":"et bandoulière","nl":"/cross body","en":"crossbody #"},
                {"code":"J28","fr":"et épaule","nl":"/schoudertas","en":"shoulder strap #"},
                {"code":"J29","fr":"et sac à dos","nl":"/rugzak","en":"backpack #"},
                {"code":"J30","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"J31","fr":"avec trousse offerte","nl":"met gratis pennenzak","en":"with free pencil case"},
                {"code":"J32","fr":"avec trousse assortie","nl":"met bijhorende pennenzak","en":"with matching pencil case"},
                {"code":"J33","fr":"avec chouchou offert","nl":"met gratis haarelastiek","en":"with free scrunchie"},
                {"code":"J34","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"J35","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"J36","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"J37","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"J38","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"J39","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"J40","fr":"réversible","nl":"omkeerbare #","en":"reversible #"},
                {"code":"J41","fr":"mini #","nl":"mini #","en":"mini #"},
                {"code":"J42","fr":"à rabat","nl":"met overslagflap","en":"foldover #"},
                {"code":"J43","fr":"cosmétiques","nl":"make-up #","en":"cosmetics #"},
                {"code":"J44","fr":"porte-cartes","nl":"met kaarthouder","en":"with card holder"},
                {"code":"J45","fr":"porte-clefs","nl":"met sleutelhanger","en":"with key ring"},
                {"code":"J46","fr":"porte-monnaie","nl":"met portemonnee","en":"with coin purse"},
                {"code":"J47","fr":"zippé","nl":"met rits","en":"zipped #"},
                {"code":"J48","fr":"canne","nl":"met stok","en":"with cane"},
                {"code":"J49","fr":"droit","nl":"langwerpige #","en":"straight #"},
                {"code":"J50","fr":"pliant","nl":"opvouwbare #","en":"foldable #"},
                {"code":"J51","fr":"500 ml","nl":"500 ml","en":"500 ml"},
                {"code":"J52","fr":"750 ml","nl":"750 ml","en":"750 ml"},
                {"code":"J53","fr":"1 l","nl":"1 l","en":"1 l"}
            ],
            "B":[
                {"code":"B1","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"B2","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"B3","fr":"hybride","nl":"hybride #","en":"hybrid #"},
                {"code":"B4","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"B5","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"B6","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"B7","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"B8","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"B9","fr":"pliable","nl":"plooibare #","en":"foldable #"},
                {"code":"B10","fr":"rigide","nl":"harde #","en":"hardside #"},
                {"code":"B11","fr":"sac à dos","nl":"rugzak","en":"backpack"},
                {"code":"B12","fr":"souple","nl":"soepele #","en":"softside #"},
                {"code":"B13","fr":"à roulettes","nl":"op wieltjes","en":"on wheels"}
            ],
            "A":[
                {"code":"A1","fr":"A4","nl":"A4 formaat","en":"A4 size #"},
                {"code":"A2","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"A3","fr":"1 compartiment","nl":"1 compartiment","en":"1-compartment #"},
                {"code":"A4","fr":"1 compartiment + PC 13\"","nl":"1 compartiment met 13\" laptopvak","en":"1-compartment # with 13\" laptop sleeve"},
                {"code":"A5","fr":"1 compartiment + PC 14\"","nl":"1 compartiment met 14\" laptopvak","en":"1-compartment # with 14\" laptop sleeve"},
                {"code":"A6","fr":"1 compartiment + PC 15\"","nl":"1 compartiment met 15\" laptopvak","en":"1-compartment # with 15\" laptop sleeve"},
                {"code":"A7","fr":"1 compartiment + PC 16\"","nl":"1 compartiment met 16\" laptopvak","en":"1-compartment # with 16\" laptop sleeve"},
                {"code":"A8","fr":"1 compartiment + PC 17\"","nl":"1 compartiment met 17\" laptopvak","en":"1-compartment # with 17\" laptop sleeve"},
                {"code":"A9","fr":"2 compartiments","nl":"2 compartimenten","en":"2-compartment #"},
                {"code":"A10","fr":"2 compartiments + PC 13\"","nl":"2 compartimenten met 13\" laptopvak","en":"2-compartment # with 13\" laptop sleeve"},
                {"code":"A11","fr":"2 compartiments + PC 14\"","nl":"2 compartimenten met 14\" laptopvak","en":"2-compartment # with 14\" laptop sleeve"},
                {"code":"A12","fr":"2 compartiments + PC 15\"","nl":"2 compartimenten met 15\" laptopvak","en":"2-compartment # with 15\" laptop sleeve"},
                {"code":"A13","fr":"2 compartiments + PC 16\"","nl":"2 compartimenten met 16\" laptopvak","en":"2-compartment # with 16\" laptop sleeve"},
                {"code":"A14","fr":"2 compartiments + PC 17\"","nl":"2 compartimenten met 17\" laptopvak","en":"2-compartment # with 17\" laptop sleeve"},
                {"code":"A15","fr":"3 compartiments","nl":"3 compartimenten","en":"3-compartment #"},
                {"code":"A16","fr":"3 compartiments + PC 13\"","nl":"3 compartimenten met 13\" laptopvak","en":"3-compartment # with 13\" laptop sleeve"},
                {"code":"A17","fr":"3 compartiments + PC 14\"","nl":"3 compartimenten met 14\" laptopvak","en":"3-compartment # with 14\" laptop sleeve"},
                {"code":"A18","fr":"3 compartiments + PC 15\"","nl":"3 compartimenten met 15\" laptopvak","en":"3-compartment # with 15\" laptop sleeve"},
                {"code":"A19","fr":"3 compartiments + PC 16\"","nl":"3 compartimenten met 16\" laptopvak","en":"3-compartment # with 16\" laptop sleeve"},
                {"code":"A20","fr":"3 compartiments + PC 17\"","nl":"3 compartimenten met 17\" laptopvak","en":"3-compartment # with 17\" laptop sleeve"},
                {"code":"A21","fr":"A4 + PC 13\"","nl":"A4 formaat met 13\" laptopvak","en":"A4 size # with 13\" laptop sleeve"},
                {"code":"A22","fr":"A4 + PC 14\"","nl":"A4 formaat met 14\" laptopvak","en":"A4 size # with 14\" laptop sleeve"},
                {"code":"A23","fr":"A4 + PC 15\"","nl":"A4 formaat met 15\" laptopvak","en":"A4 size # with 15\" laptop sleeve"},
                {"code":"A24","fr":"A4 + PC 16\"","nl":"A4 formaat met 16\" laptopvak","en":"A4 size # with 16\" laptop sleeve"},
                {"code":"A25","fr":"A4 + PC 17\"","nl":"A4 formaat met 17\" laptopvak","en":"A4 size # with 17\" laptop sleeve"},
                {"code":"A26","fr":"et bandoulière","nl":"/cross body","en":"crossbody #"},
                {"code":"A27","fr":"et épaule","nl":"/schoudertas","en":"shoulder strap #"},
                {"code":"A28","fr":"et sac à dos","nl":"/rugzak","en":"backpack #"},
                {"code":"A29","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"A30","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"A31","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"A32","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"A33","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"A34","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"A35","fr":"réversible","nl":"omkeerbare #","en":"reversible #"}
            ],
            "H":[
                {"code":"H1","fr":"1 compartiment","nl":"1 compartiment","en":"1-compartment #"},
                {"code":"H2","fr":"1 compartiment + PC 13\"","nl":"1 compartiment met 13\" laptopvak","en":"1-compartment # with 13\" laptop sleeve"},
                {"code":"H3","fr":"1 compartiment + PC 14\"","nl":"1 compartiment met 14\" laptopvak","en":"1-compartment # with 14\" laptop sleeve"},
                {"code":"H4","fr":"1 compartiment + PC 15\"","nl":"1 compartiment met 15\" laptopvak","en":"1-compartment # with 15\" laptop sleeve"},
                {"code":"H5","fr":"1 compartiment + PC 16\"","nl":"1 compartiment met 16\" laptopvak","en":"1-compartment # with 16\" laptop sleeve"},
                {"code":"H6","fr":"1 compartiment + PC 17\"","nl":"1 compartiment met 17\" laptopvak","en":"1-compartment # with 17\" laptop sleeve"},
                {"code":"H7","fr":"2 compartiments","nl":"2 compartimenten","en":"2-compartment #"},
                {"code":"H8","fr":"2 compartiments + PC 13\"","nl":"2 compartimenten met 13\" laptopvak","en":"2-compartment # with 13\" laptop sleeve"},
                {"code":"H9","fr":"2 compartiments + PC 14\"","nl":"2 compartimenten met 14\" laptopvak","en":"2-compartment # with 14\" laptop sleeve"},
                {"code":"H10","fr":"2 compartiments + PC 15\"","nl":"2 compartimenten met 15\" laptopvak","en":"2-compartment # with 15\" laptop sleeve"},
                {"code":"H11","fr":"2 compartiments + PC 16\"","nl":"2 compartimenten met 16\" laptopvak","en":"2-compartment # with 16\" laptop sleeve"},
                {"code":"H12","fr":"2 compartiments + PC 17\"","nl":"2 compartimenten met 17\" laptopvak","en":"2-compartment # with 17\" laptop sleeve"},
                {"code":"H13","fr":"3 compartiments","nl":"3 compartimenten","en":"3-compartment #"},
                {"code":"H14","fr":"3 compartiments + PC 13\"","nl":"3 compartimenten met 13\" laptopvak","en":"3-compartment # with 13\" laptop sleeve"},
                {"code":"H15","fr":"3 compartiments + PC 14\"","nl":"3 compartimenten met 14\" laptopvak","en":"3-compartment # with 14\" laptop sleeve"},
                {"code":"H16","fr":"3 compartiments + PC 15\"","nl":"3 compartimenten met 15\" laptopvak","en":"3-compartment # with 15\" laptop sleeve"},
                {"code":"H17","fr":"3 compartiments + PC 16\"","nl":"3 compartimenten met 16\" laptopvak","en":"3-compartment # with 16\" laptop sleeve"},
                {"code":"H18","fr":"3 compartiments + PC 17\"","nl":"3 compartimenten met 17\" laptopvak","en":"3-compartment # with 17\" laptop sleeve"},
                {"code":"H19","fr":"A4","nl":"A4 formaat","en":"A4 size #"},
                {"code":"H20","fr":"A4 + PC 13\"","nl":"A4 formaat met 13\" laptopvak","en":"A4 size # with 13\" laptop sleeve"},
                {"code":"H21","fr":"A4 + PC 14\"","nl":"A4 formaat met 14\" laptopvak","en":"A4 size # with 14\" laptop sleeve"},
                {"code":"H22","fr":"A4 + PC 15\"","nl":"A4 formaat met 15\" laptopvak","en":"A4 size # with 15\" laptop sleeve"},
                {"code":"H23","fr":"A4 + PC 16\"","nl":"A4 formaat met 16\" laptopvak","en":"A4 size # with 16\" laptop sleeve"},
                {"code":"H24","fr":"A4 + PC 17\"","nl":"A4 formaat met 17\" laptopvak","en":"A4 size # with 17\" laptop sleeve"},
                {"code":"H25","fr":"ajustable","nl":"verstelbare #","en":"adjustable #"},
                {"code":"H26","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"H27","fr":"et bandoulière","nl":"/cross body","en":"crossbody #"},
                {"code":"H28","fr":"et épaule","nl":"/schoudertas","en":"shoulder strap #"},
                {"code":"H29","fr":"et sac à dos","nl":"/rugzak","en":"backpack #"},
                {"code":"H30","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"H31","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"H32","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"H33","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"H34","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"H35","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"H36","fr":"réversible","nl":"omkeerbare #","en":"reversible #"},
                {"code":"H37","fr":"à rabat","nl":"met overslagflap","en":"foldover #"},
                {"code":"H38","fr":"cosmétiques","nl":"make-up #","en":"cosmetics #"},
                {"code":"H39","fr":"porte-cartes","nl":"met kaarthouder","en":"with card holder"},
                {"code":"H40","fr":"porte-clefs","nl":"met sleutelhanger","en":"with key ring"},
                {"code":"H41","fr":"porte-monnaie","nl":"met portemonnee","en":"with coin purse"},
                {"code":"H42","fr":"zippé","nl":"met rits","en":"zipped #"},
                {"code":"H43","fr":"canne","nl":"met stok","en":"with cane"},
                {"code":"H44","fr":"droit","nl":"langwerpige #","en":"straight #"},
                {"code":"H45","fr":"pliant","nl":"opvouwbare #","en":"foldable #"}
            ],
            "F":[
                {"code":"F1","fr":"1 compartiment","nl":"1 compartiment","en":"1-compartment #"},
                {"code":"F2","fr":"1 compartiment + PC 13\"","nl":"1 compartiment met 13\" laptopvak","en":"1-compartment # with 13\" laptop sleeve"},
                {"code":"F3","fr":"1 compartiment + PC 14\"","nl":"1 compartiment met 14\" laptopvak","en":"1-compartment # with 14\" laptop sleeve"},
                {"code":"F4","fr":"1 compartiment + PC 15\"","nl":"1 compartiment met 15\" laptopvak","en":"1-compartment # with 15\" laptop sleeve"},
                {"code":"F5","fr":"1 compartiment + PC 16\"","nl":"1 compartiment met 16\" laptopvak","en":"1-compartment # with 16\" laptop sleeve"},
                {"code":"F6","fr":"1 compartiment + PC 17\"","nl":"1 compartiment met 17\" laptopvak","en":"1-compartment # with 17\" laptop sleeve"},
                {"code":"F7","fr":"2 compartiments","nl":"2 compartimenten","en":"2-compartment #"},
                {"code":"F8","fr":"2 compartiments + PC 13\"","nl":"2 compartimenten met 13\" laptopvak","en":"2-compartment # with 13\" laptop sleeve"},
                {"code":"F9","fr":"2 compartiments + PC 14\"","nl":"2 compartimenten met 14\" laptopvak","en":"2-compartment # with 14\" laptop sleeve"},
                {"code":"F10","fr":"2 compartiments + PC 15\"","nl":"2 compartimenten met 15\" laptopvak","en":"2-compartment # with 15\" laptop sleeve"},
                {"code":"F11","fr":"2 compartiments + PC 16\"","nl":"2 compartimenten met 16\" laptopvak","en":"2-compartment # with 16\" laptop sleeve"},
                {"code":"F12","fr":"2 compartiments + PC 17\"","nl":"2 compartimenten met 17\" laptopvak","en":"2-compartment # with 17\" laptop sleeve"},
                {"code":"F13","fr":"3 compartiments","nl":"3 compartimenten","en":"3-compartment #"},
                {"code":"F14","fr":"3 compartiments + PC 13\"","nl":"3 compartimenten met 13\" laptopvak","en":"3-compartment # with 13\" laptop sleeve"},
                {"code":"F15","fr":"3 compartiments + PC 14\"","nl":"3 compartimenten met 14\" laptopvak","en":"3-compartment # with 14\" laptop sleeve"},
                {"code":"F16","fr":"3 compartiments + PC 15\"","nl":"3 compartimenten met 15\" laptopvak","en":"3-compartment # with 15\" laptop sleeve"},
                {"code":"F17","fr":"3 compartiments + PC 16\"","nl":"3 compartimenten met 16\" laptopvak","en":"3-compartment # with 16\" laptop sleeve"},
                {"code":"F18","fr":"3 compartiments + PC 17\"","nl":"3 compartimenten met 17\" laptopvak","en":"3-compartment # with 17\" laptop sleeve"},
                {"code":"F19","fr":"A4","nl":"A4 formaat","en":"A4 size #"},
                {"code":"F20","fr":"A4 + PC 13\"","nl":"A4 formaat met 13\" laptopvak","en":"A4 size # with 13\" laptop sleeve"},
                {"code":"F21","fr":"A4 + PC 14\"","nl":"A4 formaat met 14\" laptopvak","en":"A4 size # with 14\" laptop sleeve"},
                {"code":"F22","fr":"A4 + PC 15\"","nl":"A4 formaat met 15\" laptopvak","en":"A4 size # with 15\" laptop sleeve"},
                {"code":"F23","fr":"A4 + PC 16\"","nl":"A4 formaat met 16\" laptopvak","en":"A4 size # with 16\" laptop sleeve"},
                {"code":"F24","fr":"A4 + PC 17\"","nl":"A4 formaat met 17\" laptopvak","en":"A4 size # with 17\" laptop sleeve"},
                {"code":"F25","fr":"ajustable","nl":"verstelbare #","en":"adjustable #"},
                {"code":"F26","fr":"et bandoulière","nl":"/cross body","en":"crossbody #"},
                {"code":"F27","fr":"et épaule","nl":"/schoudertas","en":"shoulder strap #"},
                {"code":"F28","fr":"et sac à dos","nl":"/rugzak","en":"backpack #"},
                {"code":"F29","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"F30","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"F31","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"F32","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"F33","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"F34","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"F35","fr":"réversible","nl":"omkeerbare #","en":"reversible #"},
                {"code":"F36","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"F37","fr":"à rabat","nl":"met overslagflap","en":"foldover #"},
                {"code":"F38","fr":"cosmétiques","nl":"make-up #","en":"cosmetics #"},
                {"code":"F39","fr":"porte-cartes","nl":"met kaarthouder","en":"with card holder"},
                {"code":"F40","fr":"porte-clefs","nl":"met sleutelhanger","en":"with key ring"},
                {"code":"F41","fr":"porte-monnaie","nl":"met portemonnee","en":"with coin purse"},
                {"code":"F42","fr":"zippé","nl":"met rits","en":"zipped #"},
                {"code":"F43","fr":"canne","nl":"met stok","en":"with cane"},
                {"code":"F44","fr":"droit","nl":"langwerpige #","en":"straight #"},
                {"code":"F45","fr":"pliant","nl":"opvouwbare #","en":"foldable #"}
            ],
            "M":[
                {"code":"M1","fr":"1 compartiment","nl":"1 compartiment","en":"1-compartment #"},
                {"code":"M2","fr":"1 compartiment + PC 13\"","nl":"1 compartiment met 13\" laptopvak","en":"1-compartment # with 13\" laptop sleeve"},
                {"code":"M3","fr":"1 compartiment + PC 14\"","nl":"1 compartiment met 14\" laptopvak","en":"1-compartment # with 14\" laptop sleeve"},
                {"code":"M4","fr":"1 compartiment + PC 15\"","nl":"1 compartiment met 15\" laptopvak","en":"1-compartment # with 15\" laptop sleeve"},
                {"code":"M5","fr":"1 compartiment + PC 16\"","nl":"1 compartiment met 16\" laptopvak","en":"1-compartment # with 16\" laptop sleeve"},
                {"code":"M6","fr":"1 compartiment + PC 17\"","nl":"1 compartiment met 17\" laptopvak","en":"1-compartment # with 17\" laptop sleeve"},
                {"code":"M7","fr":"2 compartiments","nl":"2 compartimenten","en":"2-compartment #"},
                {"code":"M8","fr":"2 compartiments + PC 13\"","nl":"2 compartimenten met 13\" laptopvak","en":"2-compartment # with 13\" laptop sleeve"},
                {"code":"M9","fr":"2 compartiments + PC 14\"","nl":"2 compartimenten met 14\" laptopvak","en":"2-compartment # with 14\" laptop sleeve"},
                {"code":"M10","fr":"2 compartiments + PC 15\"","nl":"2 compartimenten met 15\" laptopvak","en":"2-compartment # with 15\" laptop sleeve"},
                {"code":"M11","fr":"2 compartiments + PC 16\"","nl":"2 compartimenten met 16\" laptopvak","en":"2-compartment # with 16\" laptop sleeve"},
                {"code":"M12","fr":"2 compartiments + PC 17\"","nl":"2 compartimenten met 17\" laptopvak","en":"2-compartment # with 17\" laptop sleeve"},
                {"code":"M13","fr":"3 compartiments","nl":"3 compartimenten","en":"3-compartment #"},
                {"code":"M14","fr":"3 compartiments + PC 13\"","nl":"3 compartimenten met 13\" laptopvak","en":"3-compartment # with 13\" laptop sleeve"},
                {"code":"M15","fr":"3 compartiments + PC 14\"","nl":"3 compartimenten met 14\" laptopvak","en":"3-compartment # with 14\" laptop sleeve"},
                {"code":"M16","fr":"3 compartiments + PC 15\"","nl":"3 compartimenten met 15\" laptopvak","en":"3-compartment # with 15\" laptop sleeve"},
                {"code":"M17","fr":"3 compartiments + PC 16\"","nl":"3 compartimenten met 16\" laptopvak","en":"3-compartment # with 16\" laptop sleeve"},
                {"code":"M18","fr":"3 compartiments + PC 17\"","nl":"3 compartimenten met 17\" laptopvak","en":"3-compartment # with 17\" laptop sleeve"},
                {"code":"M19","fr":"A4","nl":"A4 formaat","en":"A4 size #"},
                {"code":"M20","fr":"A4 + PC 13\"","nl":"A4 formaat met 13\" laptopvak","en":"A4 size # with 13\" laptop sleeve"},
                {"code":"M21","fr":"A4 + PC 14\"","nl":"A4 formaat met 14\" laptopvak","en":"A4 size # with 14\" laptop sleeve"},
                {"code":"M22","fr":"A4 + PC 15\"","nl":"A4 formaat met 15\" laptopvak","en":"A4 size # with 15\" laptop sleeve"},
                {"code":"M23","fr":"A4 + PC 16\"","nl":"A4 formaat met 16\" laptopvak","en":"A4 size # with 16\" laptop sleeve"},
                {"code":"M24","fr":"A4 + PC 17\"","nl":"A4 formaat met 17\" laptopvak","en":"A4 size # with 17\" laptop sleeve"},
                {"code":"M25","fr":"ajustable","nl":"verstelbare #","en":"adjustable #"},
                {"code":"M26","fr":"et bandoulière","nl":"/cross body","en":"crossbody #"},
                {"code":"M27","fr":"et épaule","nl":"/schoudertas","en":"shoulder strap #"},
                {"code":"M28","fr":"et sac à dos","nl":"/rugzak","en":"backpack #"},
                {"code":"M29","fr":"extensible","nl":"uitbreidbare #","en":"expandable #"},
                {"code":"M30","fr":"PC 13\"","nl":"met 13\" laptopvak","en":"with 13\" laptop sleeve"},
                {"code":"M31","fr":"PC 14\"","nl":"met 14\" laptopvak","en":"with 14\" laptop sleeve"},
                {"code":"M32","fr":"PC 15\"","nl":"met 15\" laptopvak","en":"with 15\" laptop sleeve"},
                {"code":"M33","fr":"PC 16\"","nl":"met 16\" laptopvak","en":"with 16\" laptop sleeve"},
                {"code":"M34","fr":"PC 17\"","nl":"met 17\" laptopvak","en":"with 17\" laptop sleeve"},
                {"code":"M35","fr":"réversible","nl":"omkeerbare #","en":"reversible #"},
                {"code":"M36","fr":"avec port USB","nl":"met USB poort","en":"with USB port"},
                {"code":"M37","fr":"à rabat","nl":"met overslagflap","en":"foldover #"},
                {"code":"M38","fr":"cosmétiques","nl":"make-up #","en":"cosmetics #"},
                {"code":"M39","fr":"porte-cartes","nl":"met kaarthouder","en":"with card holder"},
                {"code":"M40","fr":"porte-clefs","nl":"met sleutelhanger","en":"with key ring"},
                {"code":"M41","fr":"porte-monnaie","nl":"met portemonnee","en":"with coin purse"},
                {"code":"M42","fr":"zippé","nl":"met rits","en":"zipped #"},
                {"code":"M43","fr":"canne","nl":"met stok","en":"with cane"},
                {"code":"M44","fr":"droit","nl":"langwerpige #","en":"straight #"},
                {"code":"M45","fr":"pliant","nl":"opvouwbare #","en":"foldable #"},
                {"code":"M46","fr":"500 ml","nl":"500 ml","en":"500 ml"},
                {"code":"M47","fr":"750 ml","nl":"750 ml","en":"750 ml"},
                {"code":"M48","fr":"1 l","nl":"1 l","en":"1 l"}
            ],
            "C":[
                {"code":"C1","fr":"avec brides","nl":"met riempjes","en":"with straps"},
                {"code":"C2","fr":"basse","nl":"lage #","en":"low #"},
                {"code":"C3","fr":"cavalières","nl":"rij #","en":"riding #"},
                {"code":"C4","fr":"chelsea","nl":"chelsea #","en":"chelsea #"},
                {"code":"C5","fr":"cuissardes","nl":"overknee #","en":"thigh-high #"},
                {"code":"C6","fr":"de pluie","nl":"regen #","en":"rain #"},
                {"code":"C7","fr":"derby","nl":"derby #","en":"derby #"},
                {"code":"C8","fr":"genouillère","nl":"kniehoge #","en":"knee-high #"},
                {"code":"C9","fr":"mid","nl":"halfhoge #","en":"mid-calf #"},
                {"code":"C10","fr":"montante","nl":"enkelhoge #","en":"ankle #"},
                {"code":"C11","fr":"neige et froid","nl":"winter #","en":"winter #"},
                {"code":"C12","fr":"salomé","nl":"salomé #","en":"salomé #"},
                {"code":"C13","fr":"semelle compensée","nl":"met platformzool","en":"platform #"},
                {"code":"C14","fr":"stretch","nl":"stretch #","en":"stretch #"},
                {"code":"C15","fr":"talon compensé","nl":"met sleehak","en":"wedge #"},
                {"code":"C16","fr":"talon aiguille","nl":"met naaldhak","en":"stiletto heel #"},
                {"code":"C17","fr":"à talon","nl":"met hak","en":"heeled #"},
                {"code":"C18","fr":"de ski","nl":"ski #","en":"ski #"},
                {"code":"C19","fr":"plateforme","nl":"met platformzool","en":"platform #"},
                {"code":"C20","fr":"chaussettes","nl":"sok #","en":"sock #"},
                {"code":"C21","fr":"slip on","nl":"slip on #","en":"slip on #"},
                {"code":"C22","fr":"velcro","nl":"velcro #","en":"velcro #"}
            ]
          },
          sousFamillesObj: {
            "J1A":{"code":"J1A","fr":"Sac à dos","nl":"Rugzak","en":"Backpack"},
            "J1B":{"code":"J1B","fr":"Sac a dos à roulettes","nl":"Rugzak op wieltjes","en":"Wheeled schoolbag"},
            "J1C":{"code":"J1C","fr":"Cartable","nl":"Boekentas","en":"Satchel"},
            "J1D":{"code":"J1D","fr":"Cartable à roulettes","nl":"Boekentas op wieltjes","en":"Wheeled satchel"},
            "J1E":{"code":"J1E","fr":"Sac gouter","nl":"Lunchtas","en":"Lunch bag"},
            "J1F":{"code":"J1F","fr":"Sac à dos PC","nl":"Business rugzak","en":"Laptop backpack"},
            "J1G":{"code":"J1G","fr":"Sac roulettes","nl":"Tas op wieltjes","en":"Bag on wheels"},
            "J2A":{"code":"J2A","fr":"Sac bandoulière","nl":"Cross body tas","en":"Crossbody bag"},
            "J2B":{"code":"J2B","fr":"Sac porté épaule","nl":"Schoudertas","en":"Shoulder bag"},
            "J2C":{"code":"J2C","fr":"Sac porté main","nl":"Handtas","en":"Satchel"},
            "J2D":{"code":"J2D","fr":"Sac à dos","nl":"Rugzak","en":"Backpack"},
            "J2E":{"code":"J2E","fr":"Sac banane","nl":"Heuptasje","en":"Belt bag"},
            "J2F":{"code":"J2F","fr":"Sac de randonnée","nl":"Wandelrugzak","en":"Hiking backpack"},
            "J2G":{"code":"J2G","fr":"Sac de sport","nl":"Sporttas","en":"Gym bag"},
            "J3A":{"code":"J3A","fr":"Porte-monnaie","nl":"Portemonnee","en":"Coin purse"},
            "J3B":{"code":"J3B","fr":"Portefeuille","nl":"Portefeuille","en":"Wallet"},
            "J3C":{"code":"J3C","fr":"Porte-chéquier","nl":"Chequehouder","en":"Checkholder"},
            "J3D":{"code":"J3D","fr":"Tout-en-un","nl":"All in one","en":"Continental wallet"},
            "J3E":{"code":"J3E","fr":"Porte-clefs","nl":"Sleutelhanger","en":"Keychain"},
            "J3F":{"code":"J3F","fr":"Porte-cartes","nl":"Kaarthouder","en":"Cardholder"},
            "J3G":{"code":"J3G","fr":"Trousse","nl":"Pennenzak","en":"Pouch"},
            "J4A":{"code":"J4A","fr":"Parapluie","nl":"Paraplu","en":"Umbrella"},
            "J4B":{"code":"J4B","fr":"Ceinture","nl":"Riem","en":"Belt bag"},
            "J4C":{"code":"J4C","fr":"Coffret bijoux","nl":"Juwelenkoffer","en":"Jewelry box"},
            "J4D":{"code":"J4D","fr":"Coffret cadeau","nl":"Cadeaukoffer","en":"Gift box"},
            "J4E":{"code":"J4E","fr":"Led","nl":"Led","en":"Led"},
            "J4F":{"code":"J4F","fr":"Pochette","nl":"Ritsvak","en":"Front pocket"},
            "J4G":{"code":"J4G","fr":"Papeterie","nl":"Papierwaren","en":"Stationery"},
            "J4H":{"code":"J4H","fr":"Gourde","nl":"Drinkfles","en":"Drinking bottle"},
            "J4I":{"code":"J4I","fr":"Rabat amovible","nl":"Afneembare flap","en":"Detachable flap"},
            "J4J":{"code":"J4J","fr":"Casquette","nl":"Pet","en":"Cap"},
            "J4K":{"code":"J4K","fr":"Pièces détachées","nl":"Wisselstukken","en":"Replacement parts"},
            "B1A":{"code":"B1A","fr":"Valise cabine","nl":"Handbagage","en":"Cabin luggage"},
            "B1B":{"code":"B1B","fr":"Sac de voyage cabine","nl":"Reistas voor cabine","en":"Cabin duffle bag"},
            "B2A":{"code":"B2A","fr":"Valise rigide","nl":"Harde reiskoffer","en":"Hardside luggage"},
            "B2B":{"code":"B2B","fr":"Valise souple","nl":"Soepele reiskoffer","en":"Softside luggage"},
            "B2C":{"code":"B2C","fr":"Valise hybride","nl":"Hybride reiskoffer","en":"Hybrid luggage"},
            "B2D":{"code":"B2D","fr":"Lot de valises","nl":"Set reiskoffers","en":"Luggage set"},
            "B3A":{"code":"B3A","fr":"Sac de voyage","nl":"Reistas","en":"Travel bag"},
            "B3B":{"code":"B3B","fr":"Porte-habits","nl":"Kledinghoes","en":"Garment bag"},
            "B3C":{"code":"B3C","fr":"Reporter","nl":"Messenger tas","en":"Messenger bag"},
            "B3D":{"code":"B3D","fr":"Sac appareil photo","nl":"Cameratas","en":"Camera bag"},
            "B3E":{"code":"B3E","fr":"Lot de sacs de voyage","nl":"Set reistassen","en":"Set of travel bags"},
            "B4A":{"code":"B4A","fr":"Beauty case","nl":"Beauty case","en":"Beauty case"},
            "B4B":{"code":"B4B","fr":"Trousse de toilette","nl":"Toiletzak","en":"Toiletry kit"},
            "B5A":{"code":"B5A","fr":"Valise enfant","nl":"Kinderkoffer","en":"Kids luggage"},
            "B5B":{"code":"B5B","fr":"Sac de voyage enfant","nl":"Kinderreistas","en":"Kids travel bag"},
            "B6A":{"code":"B6A","fr":"Cadenas","nl":"Hangslot","en":"Lock"},
            "B6B":{"code":"B6B","fr":"Sangle à bagage","nl":"Bagageriem","en":"Luggage belt"},
            "B6C":{"code":"B6C","fr":"Pochette de voyage","nl":"Reistasje","en":"Travel wallet"},
            "B6D":{"code":"B6D","fr":"Coussin de voyage","nl":"Reiskussen","en":"Travel pillow"},
            "B6E":{"code":"B6E","fr":"Masque de repos","nl":"Slaapmasker","en":"Eye mask"},
            "B6F":{"code":"B6F","fr":"Porte-adresse","nl":"Adreslabel","en":"Luggage tag"},
            "B6G":{"code":"B6G","fr":"Roule valise","nl":"Bagagetrolley","en":"Luggage trolley"},
            "B6H":{"code":"B6H","fr":"Pèse-valise","nl":"Bagageweger","en":"Luggage scale"},
            "B6I":{"code":"B6I","fr":"Adaptateur électrique","nl":"Elektrische adapter","en":"Electric adapter"},
            "B6J":{"code":"B6J","fr":"Étui flacons","nl":"Reisflacons met hoes","en":"Travel containers"},
            "B6K":{"code":"B6K","fr":"Accessoires","nl":"Accessoires","en":"Accessoires"},
            "B6L":{"code":"B6L","fr":"Housse valise","nl":"Kofferhoes","en":"Suitcase cover"},
            "A1A":{"code":"A1A","fr":"Serviette","nl":"Aktetas","en":"Briefcase"},
            "A1B":{"code":"A1B","fr":"Porte documents (main)","nl":"Documententas","en":"Business bag"},
            "A1C":{"code":"A1C","fr":"Porte documents roulettes","nl":"Documententas op wieltjes","en":"Business bag on wheels"},
            "A1D":{"code":"A1D","fr":"Porte documents (épaule)","nl":"Business schoudertas","en":"Messenger bag"},
            "A1E":{"code":"A1E","fr":"Porte ordinateur (semi rigide)","nl":"Laptoptas","en":"Laptop bag"},
            "A1F":{"code":"A1F","fr":"Besace business","nl":"Business tas","en":"Messenger bag"},
            "A1G":{"code":"A1G","fr":"Sac à dos business","nl":"Business rugzak","en":"Backpack"},
            "A1H":{"code":"A1H","fr":"Sac à dos roulettes","nl":"Rugzak op wieltjes","en":"Wheeled backpack"},
            "A1I":{"code":"A1I","fr":"Sac docteur","nl":"Dokterstas","en":"Doctor bag"},
            "A2A":{"code":"A2A","fr":"Pilot-case","nl":"Pilot case","en":"Pilot case"},
            "A2B":{"code":"A2B","fr":"Pilot-case à roulettes","nl":"Pilot case op wieltjes","en":"Pilot case on wheels"},
            "A2C":{"code":"A2C","fr":"Attache case","nl":"Attaché koffer","en":"Attaché case"},
            "A3A":{"code":"A3A","fr":"Housse ordinateur","nl":"Laptophoes","en":"Laptop cover"},
            "A3B":{"code":"A3B","fr":"Housse tablette","nl":"Tablethoes","en":"Tablet cover"},
            "A3C":{"code":"A3C","fr":"Conférencier","nl":"Conferentiemap","en":"Portfolio"},
            "A3D":{"code":"A3D","fr":"Trousse","nl":"Pennenzak","en":"Pencil case"},
            "A3E":{"code":"A3E","fr":"Accessoire de bureau","nl":"Bureau accessoires","en":"Business accessories"},
            "H1A":{"code":"H1A","fr":"Sac bandoulière","nl":"Cross body tas","en":"Crossbody bag"},
            "H1B":{"code":"H1B","fr":"Sac porté épaule","nl":"Schoudertas","en":"Shoulder bag"},
            "H1C":{"code":"H1C","fr":"Pochette homme","nl":"Herenpocket","en":"Messenger back"},
            "H1D":{"code":"H1D","fr":"Sac banane","nl":"Heuptasje","en":"Belt bag"},
            "H1E":{"code":"H1E","fr":"Sac à dos","nl":"Rugzak","en":"Backpack"},
            "H2A":{"code":"H2A","fr":"Porte-monnaie","nl":"Portemonnee","en":"Coin purse"},
            "H2B":{"code":"H2B","fr":"Portefeuille","nl":"Portefeuille","en":"Wallet"},
            "H2C":{"code":"H2C","fr":"Porte-chéquier","nl":"Chequehouder","en":"Checkholder"},
            "H2D":{"code":"H2D","fr":"Tout-en-un","nl":"All in one","en":"Continental wallet"},
            "H2E":{"code":"H2E","fr":"Porte-clefs","nl":"Sleutelhanger","en":"Keychain"},
            "H2F":{"code":"H2F","fr":"Porte-cartes","nl":"Kaarthouder","en":"Card holder"},
            "H2G":{"code":"H2G","fr":"Porte-papiers","nl":"Papierhouder","en":"Wallet"},
            "H2H":{"code":"H2H","fr":"Pince billets","nl":"Geldclip","en":"Money clip"},
            "H2I":{"code":"H2I","fr":"Étui lunettes","nl":"Brilhouder","en":"Sunglass case"},
            "H2J":{"code":"H2J","fr":"Étui cigarettes","nl":"Sigarenetui","en":"Cigar case"},
            "H2K":{"code":"H2K","fr":"Étui stylos","nl":"Pennenetui","en":"Pen case"},
            "H2L":{"code":"H2L","fr":"Étui téléphone","nl":"Telefoonetui","en":"Phone case"},
            "H2N":{"code":"H2N","fr":"Trousse","nl":"Etui","en":"Pouch"},
            "H2O":{"code":"H2O","fr":"Agenda","nl":"Agenda","en":"Diary"},
            "H2P":{"code":"H2P","fr":"Étui passeport","nl":"Paspoorthoes","en":"Passport holder"},
            "H3A":{"code":"H3A","fr":"Gants","nl":"Handschoenen","en":"Gloves"},
            "H3B":{"code":"H3B","fr":"Parapluie","nl":"Paraplu","en":"Umbrella"},
            "H3C":{"code":"H3C","fr":"Ceinture","nl":"Riem","en":"Belt"},
            "H3D":{"code":"H3D","fr":"Bretelles","nl":"Bretellen","en":"Braces"},
            "H3E":{"code":"H3E","fr":"Foulard","nl":"Foulard","en":"Scarf"},
            "H3F":{"code":"H3F","fr":"Écharpe","nl":"Sjaal","en":"Scarf"},
            "H3G":{"code":"H3G","fr":"Chapeau","nl":"Hoed","en":"Hat"},
            "H3H":{"code":"H3H","fr":"Coffret cadeaux","nl":"Cadeaukoffer","en":"Gift box"},
            "H3I":{"code":"H3I","fr":"Sac provision à roulettes","nl":"Boodschappentrolley","en":"Wheeled grocery bag"},
            "H3J":{"code":"H3J","fr":"Sac provision","nl":"Boodschappentas","en":"Grocery bag"},
            "H3K":{"code":"H3K","fr":"Bijoux","nl":"Juwelen","en":"Jewelry"},
            "H3L":{"code":"H3L","fr":"Bonnet","nl":"Muts","en":"Beanie"},
            "H3M":{"code":"H3M","fr":"Étole","nl":"Sjaal","en":"Scarf"},
            "H3N":{"code":"H3N","fr":"Masque lavable","nl":"Wasbaar mondmasker","en":"Washable face mask"},
            "H3O":{"code":"H3O","fr":"Casquette","nl":"Pet","en":"Cap"},
            "H3P":{"code":"H3P","fr":"Bandoulière de sac","nl":"Schouderriem","en":"Shoulder strap"},
            "F1A":{"code":"F1A","fr":"Sac bandoulière","nl":"Cross body tas","en":"Crossbody bag"},
            "F1B":{"code":"F1B","fr":"Sac porté épaule","nl":"Schoudertas","en":"Shoulder bag"},
            "F1C":{"code":"F1C","fr":"Sac porté main","nl":"Handtas","en":"Satchel"},
            "F1D":{"code":"F1D","fr":"Sac banane","nl":"Heuptasje","en":"Belt bag"},
            "F1E":{"code":"F1E","fr":"Sac à dos","nl":"Rugzak","en":"Backpack"},
            "F1F":{"code":"F1F","fr":"Sac de cérémomie","nl":"Clutch","en":"Clutch"},
            "F1G":{"code":"F1G","fr":"Sac de soirée","nl":"Avondtas","en":"Evening bag"},
            "F2A":{"code":"F2A","fr":"Porte-monnaie","nl":"Portemonnee","en":"Coin purse"},
            "F2B":{"code":"F2B","fr":"Portefeuille","nl":"Portefeuille","en":"Wallet"},
            "F2C":{"code":"F2C","fr":"Porte-chéquier","nl":"Chequehouder","en":"Checkholder"},
            "F2D":{"code":"F2D","fr":"Tout-en-un","nl":"All in one","en":"Continental wallet"},
            "F2E":{"code":"F2E","fr":"Porte-clefs","nl":"Sleutelhanger","en":"Keychain"},
            "F2F":{"code":"F2F","fr":"Porte-cartes","nl":"Kaarthouder","en":"Card holder"},
            "F2G":{"code":"F2G","fr":"Porte-papiers","nl":"Papierhouder","en":"Wallet"},
            "F2H":{"code":"F2H","fr":"Étui lunettes","nl":"Brilhouder","en":"Sunglass case"},
            "F2I":{"code":"F2I","fr":"Étui cigarettes","nl":"Sigarettenetui","en":"Cigar case"},
            "F2J":{"code":"F2J","fr":"Étui stylo","nl":"Pennenetui","en":"Pen case"},
            "F2K":{"code":"F2K","fr":"Étui téléphone","nl":"Telefoonetui","en":"Phone case"},
            "F2L":{"code":"F2L","fr":"Trousse","nl":"Etui","en":"Pouch"},
            "F2M":{"code":"F2M","fr":"Agenda","nl":"Agenda","en":"Diary"},
            "F2N":{"code":"F2N","fr":"Étui passeport","nl":"Paspoorthoes","en":"Passport holder"},
            "F3A":{"code":"F3A","fr":"Gants","nl":"Handschoenen","en":"Gloves"},
            "F3B":{"code":"F3B","fr":"Parapluie","nl":"Paraplu","en":"Umbrella"},
            "F3C":{"code":"F3C","fr":"Ceinture","nl":"Riem","en":"Belt"},
            "F3D":{"code":"F3D","fr":"Foulard","nl":"Foulard","en":"Scarf"},
            "F3E":{"code":"F3E","fr":"Écharpe","nl":"Sjaal","en":"Scarf"},
            "F3F":{"code":"F3F","fr":"Chapeau","nl":"Hoed","en":"Hat"},
            "F3G":{"code":"F3G","fr":"Porte sac","nl":"Tashaakje","en":"Bag holder"},
            "F3H":{"code":"F3H","fr":"Organiseur de sac","nl":"Tas organizer","en":"Bag organizer"},
            "F3I":{"code":"F3I","fr":"Coffret bijoux","nl":"Juwelenkoffer","en":"Jewelry box"},
            "F3J":{"code":"F3J","fr":"Coffret cadeau","nl":"Cadeaukoffer","en":"Gift box"},
            "F3K":{"code":"F3K","fr":"Sac provision à roulettes","nl":"Boodschappentrolley","en":"Wheeled grocery bag"},
            "F3L":{"code":"F3L","fr":"Sac provision","nl":"Boodschappentas","en":"Grocery bag"},
            "F3M":{"code":"F3M","fr":"Bijoux","nl":"Juwelen","en":"Jewelry"},
            "F3N":{"code":"F3N","fr":"Bijoux de sac","nl":"Tashengsel","en":"Bag handle"},
            "F3O":{"code":"F3O","fr":"Bandoulière de sac","nl":"Schouderriem","en":"Shoulder strap"},
            "F3P":{"code":"F3P","fr":"Bonnet","nl":"Muts","en":"Beanie"},
            "F3Q":{"code":"F3Q","fr":"Étole","nl":"Sjaal","en":"Scarf"},
            "F3R":{"code":"F3R","fr":"Masque lavable","nl":"Wasbaar mondmasker","en":"Washable face mask"},
            "F3S":{"code":"F3S","fr":"Coque téléphone","nl":"Telefoonhoesje","en":"Phone cover"},
            "F3T":{"code":"F3T","fr":"Casquette","nl":"Pet","en":"Cap"},
            "F3U":{"code":"F3U","fr":"Chaine coque téléphone","nl":"Ketting voor telefoonhoesje","en":"Chain for phone cover"},
            "F3V":{"code":"F3V","fr":"Bandoulière coque téléphone","nl":"Schouderriem voor telefoonhoesje","en":"Shoulder strap for phone cover"},
            "F3W":{"code":"F3W","fr":"Languette","nl":"Lipje","en":"Tab"},
            "F3X":{"code":"F3X","fr":"Eventail","nl":"Waaier","en":"Fan"},
            "M1A":{"code":"M1A","fr":"Sac bandoulière","nl":"Cross body tas","en":"Crossbody bag"},
            "M1B":{"code":"M1B","fr":"Sac porté épaule","nl":"Schoudertas","en":"Shoulder bag"},
            "M1C":{"code":"M1C","fr":"Sac porté main","nl":"Handtas","en":"Satchel"},
            "M1D":{"code":"M1D","fr":"Sac banane","nl":"Heuptasje","en":"Belt bag"},
            "M1E":{"code":"M1E","fr":"Sac à dos","nl":"Rugzak","en":"Backpack"},
            "M2A":{"code":"M2A","fr":"Porte-monnaie","nl":"Portemonnee","en":"Coin purse"},
            "M2B":{"code":"M2B","fr":"Portefeuille","nl":"Portefeuille","en":"Wallet"},
            "M2C":{"code":"M2C","fr":"Porte-chéquier","nl":"Chequehouder","en":"Checkholder"},
            "M2D":{"code":"M2D","fr":"Tout-en-un","nl":"All in one","en":"Continental wallet"},
            "M2E":{"code":"M2E","fr":"Porte-clefs","nl":"Sleutelhanger","en":"Keychain"},
            "M2F":{"code":"M2F","fr":"Porte-cartes","nl":"Kaarthouder","en":"Card holder"},
            "M2G":{"code":"M2G","fr":"Porte-papiers","nl":"Papierhouder","en":"Wallet"},
            "M2H":{"code":"M2H","fr":"Étui lunette","nl":"Brilhouder","en":"Sunglass case"},
            "M2I":{"code":"M2I","fr":"Étui cigarette","nl":"Sigarettenetui","en":"Cigar case"},
            "M2J":{"code":"M2J","fr":"Étui stylos","nl":"Pennenetui","en":"Pen case"},
            "M2K":{"code":"M2K","fr":"Étui téléphone","nl":"Telefoonetui","en":"Phone case"},
            "M2M":{"code":"M2M","fr":"Trousse","nl":"Etui","en":"Pouch"},
            "M2N":{"code":"M2N","fr":"Agenda","nl":"Agenda","en":"Diary"},
            "M2O":{"code":"M2O","fr":"Bijoux","nl":"Juwelen","en":"Jewelry"},
            "M2P":{"code":"M2P","fr":"Étui passeport","nl":"Paspoorthouder","en":"Passport holder"},
            "M3A":{"code":"M3A","fr":"Gants","nl":"Handschoenen","en":"Gloves"},
            "M3B":{"code":"M3B","fr":"Parapluie","nl":"Paraplu","en":"Umbrella"},
            "M3C":{"code":"M3C","fr":"Ceinture","nl":"Riem","en":"Belt"},
            "M3D":{"code":"M3D","fr":"Écharpe","nl":"Sjaal","en":"Scarf"},
            "M3E":{"code":"M3E","fr":"Chapeau","nl":"Hoed","en":"Scharf"},
            "M3F":{"code":"M3F","fr":"Coffret cadeau","nl":"Cadeaukoffer","en":"Gift box"},
            "M3G":{"code":"M3G","fr":"Sac provision à roulettes","nl":"Boodschappentrolley","en":"Wheeled grocery bag"},
            "M3H":{"code":"M3H","fr":"Sac provision","nl":"Boodschappentas","en":"Grocery bag"},
            "M3I":{"code":"M3I","fr":"Bonnet","nl":"Muts","en":"Beanie"},
            "M3J":{"code":"M3J","fr":"Étole","nl":"Sjaal","en":"Scarf"},
            "M3K":{"code":"M3K","fr":"Carte postale","nl":"Postkaart","en":"Postcard"},
            "M3L":{"code":"M3L","fr":"Marque page","nl":"Bladwijzer","en":"Bookmark"},
            "M3M":{"code":"M3M","fr":"Vide poche","nl":"Sleutelbakje","en":"Key tray"},
            "M3N":{"code":"M3N","fr":"Masque lavable","nl":"Wasbaar mondmasker","en":"Washable face mask"},
            "M3O":{"code":"M3O","fr":"Gourde","nl":"Drinkfles","en":"Drinking bottle"},
            "M3P":{"code":"M3P","fr":"Casquette","nl":"Pet","en":"Cap"},
            "C1A":{"code":"C1A","fr":"Ballerines","nl":"Ballerinas","en":"Ballerinas"},
            "C1B":{"code":"C1B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C1C":{"code":"C1C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C1D":{"code":"C1D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C1E":{"code":"C1E","fr":"Bottines","nl":"Enkellaarsjes","en":"Boots"},
            "C1F":{"code":"C1F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C1G":{"code":"C1G","fr":"Escarpins","nl":"Pumps","en":"Pumps"},
            "C1H":{"code":"C1H","fr":"Espadrilles","nl":"Espadrilles","en":"Espadrilles"},
            "C1I":{"code":"C1I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C1J":{"code":"C1J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C1K":{"code":"C1K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C1L":{"code":"C1L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C1M":{"code":"C1M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C1N":{"code":"C1N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C1O":{"code":"C1O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C1P":{"code":"C1P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat shoes"},
            "C1Q":{"code":"C1Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C1R":{"code":"C1R","fr":"Santiags","nl":"Santiago laarzen","en":"Santiago boots"},
            "C1S":{"code":"C1S","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C1T":{"code":"C1T","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "C2B":{"code":"C2B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C2C":{"code":"C2C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C2D":{"code":"C2D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C2E":{"code":"C2E","fr":"Bottines","nl":"Enkellaarzen","en":"Boots"},
            "C2F":{"code":"C2F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C2H":{"code":"C2H","fr":"Espadrilles","nl":"Espadrilles","en":"Espadrilles"},
            "C2I":{"code":"C2I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C2J":{"code":"C2J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C2K":{"code":"C2K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C2L":{"code":"C2L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C2M":{"code":"C2M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C2N":{"code":"C2N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C2O":{"code":"C2O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C2P":{"code":"C2P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat shoes"},
            "C2Q":{"code":"C2Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C2R":{"code":"C2R","fr":"Santiags","nl":"Santiago laarzen","en":"Santiago boots"},
            "C2S":{"code":"C2S","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C2T":{"code":"C2T","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "C3A":{"code":"C3A","fr":"Ballerines","nl":"Ballerinas","en":"Ballerinas"},
            "C3B":{"code":"C3B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C3C":{"code":"C3C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C3D":{"code":"C3D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C3E":{"code":"C3E","fr":"Bottines","nl":"Enkellaarsjes","en":"Boots"},
            "C3F":{"code":"C3F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C3G":{"code":"C3G","fr":"Escarpins","nl":"Pumps","en":"Pumps"},
            "C3H":{"code":"C3H","fr":"Espadrilles","nl":"Espadrilles","en":"Espadrilles"},
            "C3I":{"code":"C3I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C3J":{"code":"C3J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C3K":{"code":"C3K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C3L":{"code":"C3L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C3M":{"code":"C3M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C3N":{"code":"C3N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C3O":{"code":"C3O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C3P":{"code":"C3P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat choas"},
            "C3Q":{"code":"C3Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C3R":{"code":"C3R","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C3S":{"code":"C3S","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "C4B":{"code":"C4B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C4C":{"code":"C4C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C4D":{"code":"C4D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C4E":{"code":"C4E","fr":"Bottines","nl":"Enkellaarzen","en":"Boots"},
            "C4F":{"code":"C4F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C4I":{"code":"C4I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C4J":{"code":"C4J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C4K":{"code":"C4K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C4L":{"code":"C4L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C4M":{"code":"C4M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C4N":{"code":"C4N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C4O":{"code":"C4O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C4P":{"code":"C4P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat shoes"},
            "C4Q":{"code":"C4Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C4R":{"code":"C4R","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C4S":{"code":"C4S","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "C5A":{"code":"C5A","fr":"Mousse strech","nl":"Stretch mousse","en":"Stretch foam"},
            "C5B":{"code":"C5B","fr":"Imperméabilisant","nl":"Impregneerspray","en":"Waterproofer"},
            "C5C":{"code":"C5C","fr":"Nettoyant cuir","nl":"Ledercrème","en":"Leather cleaner"},
            "C5D":{"code":"C5D","fr":"Cirage","nl":"Schoenpoets","en":"Polish"},
            "C5E":{"code":"C5E","fr":"Éponge lustrante","nl":"Glansspons","en":"Shoe shine sponge"},
            "C5F":{"code":"C5F","fr":"Brosse à reluire","nl":"Glansborstel","en":"Shoe shine brush"},
            "C5G":{"code":"C5G","fr":"Gomme nubuck","nl":"Nubuck gom","en":"Suède eraser"},
            "C5H":{"code":"C5H","fr":"Brosse daim ou nubuck","nl":"Borstel voor daim","en":"Suède brush"},
            "C5I":{"code":"C5I","fr":"Chausse-pieds","nl":"Schoenlepel","en":"Shoe horn"},
            "C5J":{"code":"C5J","fr":"Semelles","nl":"Zolen","en":"Insole"},
            "C5K":{"code":"C5K","fr":"Lacets","nl":"Veters","en":"Laces"},
            "C5L":{"code":"C5L","fr":"Décoration de chaussures","nl":"Schoendecoratie","en":"Shoe decorations"},
            "C5M":{"code":"C5M","fr":"Chaussettes","nl":"Sokken","en":"Socks"},
            "C5N":{"code":"C5N","fr":"Kit entretien","nl":"Onderhoudskit","en":"Maintenance kit"},
            "C6B":{"code":"C6B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C6C":{"code":"C6C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C6D":{"code":"C6D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C6E":{"code":"C6E","fr":"Bottines","nl":"Enkellaarzen","en":"Boots"},
            "C6F":{"code":"C6F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C6H":{"code":"C6H","fr":"Espadrilles","nl":"Espadrilles","en":"Espadrilles"},
            "C6I":{"code":"C6I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C6J":{"code":"C6J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C6K":{"code":"C6K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C6L":{"code":"C6L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C6M":{"code":"C6M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C6N":{"code":"C6N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C6O":{"code":"C6O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C6P":{"code":"C6P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat shoes"},
            "C6Q":{"code":"C6Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C6R":{"code":"C6R","fr":"Santiags","nl":"Santiago laarzen","en":"Santiago boots"},
            "C6S":{"code":"C6S","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C6T":{"code":"C6T","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "C7B":{"code":"C7B","fr":"Sneakers","nl":"Sneakers","en":"Sneakers"},
            "C7C":{"code":"C7C","fr":"Boots","nl":"Boots","en":"Boots"},
            "C7D":{"code":"C7D","fr":"Bottes","nl":"Laarzen","en":"Boots"},
            "C7E":{"code":"C7E","fr":"Bottines","nl":"Enkellaarzen","en":"Boots"},
            "C7F":{"code":"C7F","fr":"Chaussures de ville","nl":"Stadsschoenen","en":"Formal shoes"},
            "C7H":{"code":"C7H","fr":"Espadrilles","nl":"Espadrilles","en":"Espadrilles"},
            "C7I":{"code":"C7I","fr":"Mocassins","nl":"Mocassins","en":"Moccasins"},
            "C7J":{"code":"C7J","fr":"Mules","nl":"Slippers","en":"Slippers"},
            "C7K":{"code":"C7K","fr":"Sandales","nl":"Sandalen","en":"Sandals"},
            "C7L":{"code":"C7L","fr":"Nu-pieds","nl":"Open sandalen","en":"Flip flops"},
            "C7M":{"code":"C7M","fr":"Chaussons","nl":"Pantoffels","en":"Slippers"},
            "C7N":{"code":"C7N","fr":"Tongs","nl":"Teenslippers","en":"Flip flops"},
            "C7O":{"code":"C7O","fr":"Chelsea boots","nl":"Chelsea boots","en":"Chelsea boots"},
            "C7P":{"code":"C7P","fr":"Chaussures bateau","nl":"Bootschoenen","en":"Boat shoes"},
            "C7Q":{"code":"C7Q","fr":"Claquettes","nl":"Slippers","en":"Flip flops"},
            "C7R":{"code":"C7R","fr":"Santiags","nl":"Santiago laarzen","en":"Santiago boots"},
            "C7S":{"code":"C7S","fr":"Chaussures richelieu","nl":"Richelieu schoenen","en":"Richelieu shoes"},
            "C7T":{"code":"C7T","fr":"Chaussures derbies","nl":"Derby veterschoenen","en":"Derby shoes"},
            "V1A":{"code":"V1A","fr":"Blouson","nl":"Jack","en":"Jacket"},
            "V1B":{"code":"V1B","fr":"Veste","nl":"Jas","en":"Jacket"},
            "V1C":{"code":"V1C","fr":"Blazer","nl":"Blazer","en":"Blazer"},
            "V1D":{"code":"V1D","fr":"Manteau","nl":"Mantel","en":"Coat"},
            "V1E":{"code":"V1E","fr":"Gilet","nl":"Vest","en":"Vest"},
            "V1F":{"code":"V1F","fr":"Pantalon","nl":"Broek","en":"Trousers"},
            "V1G":{"code":"V1G","fr":"Jupe","nl":"Rok","en":"Skirt"},
            "V1H":{"code":"V1H","fr":"Robe","nl":"Jurk","en":"Dress"},
            "V1J":{"code":"V1J","fr":"Bermuda","nl":"Bermuda","en":"Bermudas"},
            "V1K":{"code":"V1K","fr":"Vêtement textile","nl":"Textiel kleding","en":"Textile garment"},
            "V2A":{"code":"V2A","fr":"Blouson","nl":"Jack","en":"Jacket"},
            "V2B":{"code":"V2B","fr":"Veste","nl":"Jas","en":"Jacket"},
            "V2C":{"code":"V2C","fr":"Manteau","nl":"Mantel","en":"Coat"},
            "V3A":{"code":"V3A","fr":"Blouson","nl":"Jack","en":"Jacket"},
            "V3B":{"code":"V3B","fr":"Veste","nl":"Jas","en":"Jacket"},
            "V3C":{"code":"V3C","fr":"Blazer","nl":"Blazer","en":"Blazer"},
            "V3D":{"code":"V3D","fr":"Manteau","nl":"Mantel","en":"Coat"},
            "V3E":{"code":"V3E","fr":"Gilet","nl":"Vest","en":"Vest"},
            "V3F":{"code":"V3F","fr":"Pantalon","nl":"Broek","en":"Trousers"},
            "V3G":{"code":"V3G","fr":"Vêtement textile","nl":"Textiel kleding","en":"Textile garment"},
            "V4A":{"code":"V4A","fr":"Blouson","nl":"Jack","en":"Jacket"},
            "V4B":{"code":"V4B","fr":"Veste","nl":"Jas","en":"Jacket"},
            "V4C":{"code":"V4C","fr":"Manteau","nl":"Mantel","en":"Coat"},
            "V5A":{"code":"V5A","fr":"Blouson","nl":"Jack","en":"Jacket"},
            "V5B":{"code":"V5B","fr":"Veste","nl":"Jas","en":"Jacket"},
            "V5C":{"code":"V5C","fr":"Blazer","nl":"Blazer","en":"Blazer"},
            "V5D":{"code":"V5D","fr":"Manteau","nl":"Mantel","en":"Coat"},
            "V5E":{"code":"V5E","fr":"Gilet","nl":"Vest","en":"Vest"},
            "D1A":{"code":"D1A","fr":"Sac et sachet","nl":"Zak(jes)","en":"Bag(s)"},
            "D1B":{"code":"D1B","fr":"Emballage cadeau","nl":"Cadeauverpakking","en":"Gift wrap"},
            "D1C":{"code":"D1C","fr":"Matériel d'emballage","nl":"Verpakkingsmateriaal","en":"Wrapping paper"},
            "D1D":{"code":"D1D","fr":"Fourniture emballage","nl":"Verpakkingsbenodigdheden","en":"Wrapping material"},
            "D2A":{"code":"D2A","fr":"Produit d'entretien","nl":"Onderhoudsproducten","en":"Maintenance products"},
            "D2B":{"code":"D2B","fr":"Matériel d'entretien","nl":"Onderhoudsmateriaal","en":"Maintenance material"},
            "D3A":{"code":"D3A","fr":"Impression","nl":"Drukwerk","en":"Print"},
            "D3B":{"code":"D3B","fr":"Matériel administratif","nl":"Administratief materiaal","en":"Administrative material"},
            "D3C":{"code":"D3C","fr":"Fourniture administrative","nl":"Administratieve benodigdheden","en":"Administrative tools"},
            "D4A":{"code":"D4A","fr":"Réparation","nl":"Reparatie","en":"Reparations"},
            "D5A":{"code":"D5A","fr":"Matériel publicitaire","nl":"Publiciteitsmateriaal","en":"Advertising"},
            "D5B":{"code":"D5B","fr":"Affichage","nl":"Affichage","en":"Display materials"},
            "D5C":{"code":"D5C","fr":"Cadeau publicitaire","nl":"Publicitair cadeau","en":"Advertising gift"},
            "D6A":{"code":"D6A","fr":"Matériel","nl":"Materiaal","en":"Material"},
            "D6B":{"code":"D6B","fr":"Autre","nl":"Andere","en":"Other"},
            "D6C":{"code":"D6C","fr":"Parking","nl":"Parking","en":"Parking"},
            "D6D":{"code":"D6D","fr":"Antivol","nl":"Anti diefstal","en":"Anti theft"},
            "D7A":{"code":"D7A","fr":"Petit outillage","nl":"Klein gereedschap","en":"Small tools"},
            "D8A":{"code":"D8A","fr":"Uniforme","nl":"Uniform","en":"Uniform"}
          }

        }
    },
    mutations: {
        updateArticlePrice(state, { marque, theme, reference, barcode, vte_euro, prix_promo, type_promo }) {
            const article = state.articles[marque][theme][reference][barcode];
            article.vte_euro = vte_euro;
            article.prix_promo = prix_promo;
            article.type_promo = type_promo;
          },
        updateComposition(state, payload) {
        state.composition = payload;
        },
        updateCompositions(state, payload) {
        state.compositions = payload;
        },
        updateArticleStock(state, { marque, theme, reference, barcode, stock }) {
        state.articles[marque][theme][reference][barcode].stock = stock;
        },
        updateArticleRepartition(state, { marque, theme, reference, barcode, repart }) {
        state.articles[marque][theme][reference][barcode].repart = repart;
        },
        setSubTypeMap(state,payload){
          state.subTypeMap=payload
        } ,
        setClientIP(state,payload){
          state.ip=payload
        } ,
        setTokenY2(state,payload){
          state.token_y2=payload
        } ,
        setDate(state,payload){
          state.date=payload
        },
        addmarque (state,payload){
          state.marque=payload
        },
        addDateLivraison (state,payload){
          state.dateLivraisons=payload
        },
        updateCodeFournisseur(state,payload){
          state.codeFournisseur={updated:!state.codeFournisseur.updated,code:payload}
        },
        addArticlesFrep (state,payload){
          state.frep.articles=payload
        },
        setArticlesBackUp (state,payload){
          state.articlesBackUp=payload
        },
        addSingleArticlesFrep (state,payload){
          
          // state.frep.articles=payload
          // if (!state.frep.articles[payload.code_marque]) {
          //   state.frep.articles[payload.code_marque] = {};
          // }
          
          // Initialiser code_theme si n'existe pas
          if (!state.frep.articles[payload.code_theme]) {
              state.frep.articles[payload.code_theme] = {};
          }
          
          // Initialiser reference_y2 si n'existe pas
          if (!state.frep.articles[payload.code_theme][payload.reference_y2]) {
              state.frep.articles[payload.code_theme][payload.reference_y2] = {};
          }
          
          // Ajouter l'article avec codebarre comme clé
          state.frep.articles[payload.code_theme][payload.reference_y2][payload.codebarre] = { ...payload };
        },
        updateComponent(state,payload){
          state.component=payload
        },
        updateIsChangedCol(state,payload){
          state.isChangedCol[payload.key]=payload.value
        },
        updateCAB(state,payload){
          state.cab=payload
        },
        addPhotos(state,payload){
          state.photoLinks.exist=payload.exist
          state.photoLinks.link.push(payload.links)
          state.photoLinks.id.push(payload.id)
        },
        deletePhotos(state,payload){
          state.photoLinks=payload
        },
        addSignature(state,payload){
          state.signature=payload
        },
        updateglobalID(state,payload){
          state.countId=payload
        },
        updateBarCode(state,payload){
          state.scanBarCode=payload
        },
        updateWaiting(state){
          state.waiting=!state.waiting
        },
        increment (state) {
          state.count++
        },
        addArticles (state,payload){
          state.articles=payload
        },
        stockArticles(state,payload){
          state.stockArticles=payload},
        updateCollection (state,payload){
             state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].collection=payload.collection.newcol
        },
        updateCollectionColor (state,payload){
          if(payload.collection){
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].collection=payload.collection.newcol
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=
          {...state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol,ficheArticle:payload.localChangedCol.ficheArticle}
          }else{
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=payload.localChangedCol
          }
          
        },
        updatePrix (state,payload){
          state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].vte_euro=payload.prix.newPrix
          if(payload.prix.newRemise){
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=payload.prix.newPrix*(1-payload.prix.newRemise.split('%')[0]/100)
          }
          
        },
        updatePromo (state,payload){
          if (payload.prix.newPrix.toString().match(/%/)) {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=Number(state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].vte_euro*(1-payload.prix.newPrix.split('%')[0]/100)).toFixed(1)
          }else{
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=payload.prix.newPrix
          }
        },
        addTypePromo (state,payload){
          if (payload.prix.newType!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].type_promo=payload.prix.newType
          }else if(payload.prix.newType=='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].type_promo=''
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].prix_promo=''
          }
        },
        updateRepart (state,payload){
          if (payload.repart.newRepart!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].repart[payload.repart.mag]=payload.repart.newRepart
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol=
          {...state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key].localChangedCol,repart:payload.localChangedCol.repart}
          }
        },
        updateReference (state,payload){
          if (payload.data.value!='') {
            state.articles[payload.referenceCol.code_marque][payload.referenceCol.code_theme][payload.referenceCol.reference_y2][payload.key][payload.data.champs]=payload.data.value
          }
        },
        addmarques(state,payload){
          state.marques=payload
        },
        addBarcode(state,payload){
          state.barcodeFinded=payload
        },
        addRayons(state,payload){
          state.rayons=payload
        },
        addFamilles(state,payload){
          state.familles=payload
        },
        addSousFamilles(state,payload){
          state.sousFamilles=payload
        },
        addThemes(state,payload){
          state.themes=payload
        },
        addRowArticle(state,payload){
          state.articlesFripe.push(payload)
        },
        deleteArticles(state){
          state.articlesFripe=[]
        },
        deleteRowArticle(state,payload){
          state.articlesFripe=state.articlesFripe.filter(el=>el.id!=payload.id)
        },
        editRowArticle(state,payload){
          
          for(let item in state.articlesFripe){
            if(state.articlesFripe[item].id==payload.id){
              state.articlesFripe[item][payload.champs]=payload.value
              state.articlesFripe[item].id=state.articlesFripe[item].id.substring(0,10)+state.articlesFripe[item].libCouleur.substring(0,2)
              state.articlesFripe[item].refFourn=state.articlesFripe[item].prixPublicTTC+state.articlesFripe[item].refFourn.substring(state.articlesFripe[item].refFourn.length-5)
              state.articlesFripe[item].nomProduit=state.articlesFripe[item].refFourn
              state.articlesFripe[item].totalBrut=state.articlesFripe[item].qteCommande*state.articlesFripe[item].prixAchatHT,
              state.articlesFripe[item].coefBrut=state.articlesFripe[item].prixAchatHT&&state.articlesFripe[item].prixPublicTTC?Number(state.articlesFripe[item].prixPublicTTC/state.articlesFripe[item].prixAchatHT).toFixed(2):0,
              state.articlesFripe[item].totalPVpublic=state.articlesFripe[item].qteCommande&&state.articlesFripe[item].prixPublicTTC?state.articlesFripe[item].qteCommande*state.articlesFripe[item].prixPublicTTC:0
              //console.log(state.articlesFripe[item]);
            }
          }
          
        },
        editRowArticleFripe(state,payload){
          for(let item in state.articlesFripe){
            if(state.articlesFripe[item].id==payload.oldId){
              state.articlesFripe[item]=payload
            }
          }
        },
        editRowArticleReception(state,payload){
          for(let reception in state.listeReceptions.receptions){
            if(state.listeReceptions.receptions[reception].title==payload.title){
              for(let article in state.listeReceptions.receptions[reception].articles){
                if(state.listeReceptions.receptions[reception].articles[article].id==payload.id){
                  
                  if(payload.champs=='prixPublicTTC'){
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=payload.value
                    state.listeReceptions.receptions[reception].articles[article].prixAchatHT=(payload.value/1.8).toFixed(1)
                  }else if(payload.champs=='prixAchatHT'){
                    state.listeReceptions.receptions[reception].articles[article].prixAchatHT=payload.value
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=(payload.value*1.8).toFixed(1)
                  } else if(payload.champs=='grade' || payload.champs=='prixAchatOrigine'){
                    // console.log(state.listeReceptions.receptions[reception].articles[article]);
                    if(payload.champs=='prixAchatOrigine'){
                      state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine=payload.value
                    }else if(payload.champs=='grade'){
                      state.listeReceptions.receptions[reception].articles[article].grade=payload.value
                    }
                    
                    
                    switch (state.listeReceptions.receptions[reception].articles[article].grade.split('-')[0]){
                      case "A":   state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.35).toFixed(1);
                        state.listeReceptions.receptions[reception].articles[article].grade='A-Excellent état'
                      break
                      case "B":  state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.30).toFixed(1)
                        state.listeReceptions.receptions[reception].articles[article].grade='B-très bon état'
                      break
                      case "C": state.listeReceptions.receptions[reception].articles[article].prixAchatHT= Number(state.listeReceptions.receptions[reception].articles[article].prixAchatOrigine*0.25).toFixed(1)
                        state.listeReceptions.receptions[reception].articles[article].grade='C-Bon état'
                      break 
                    }
                    state.listeReceptions.receptions[reception].articles[article].prixPublicTTC=(1.8*state.listeReceptions.receptions[reception].articles[article].prixAchatHT).toFixed(1)
                  }
                  state.listeReceptions.receptions[reception].articles[article].totalBrut=state.listeReceptions.receptions[reception].articles[article].prixAchatHT*state.listeReceptions.receptions[reception].articles[article].qteCommande
                }
              }
            }
          }
        },
        terminerReception(state,payload){
          for(let reception in state.listeReceptions.receptions){
            if(state.listeReceptions.receptions[reception].title==payload.title){
              state.listeReceptions.receptions[reception]={...state.listeReceptions.receptions[reception],termine:'true'}
            }
          }
        }
        ,
        addClient(state,payload){
          state.clients=payload
        },
        addNumBon(state,payload){
          state.numeroBon=payload
        },
        updateDialogprixAchatHT(state,payload){
          state.dialogprixAchatHT=payload
        },
        updatephoto(state,payload){
          state.photoLinks.exist=payload
        },
        addListeReceptions(state,payload){
          state.listeReceptions=payload
        },
        deletePhoto(state,payload){
          state.photoLinks.id=state.photoLinks.id.filter(el=>el!=payload)
        },
        addUser(state,payload){
          state.user=payload
        },
        addReception(state,payload){
          state.articlesFripe=payload
        },
        deletePromo(state,payload){
          for (let art in state.articles[payload.marque][payload.theme][payload.reference]){
            state.articles[payload.marque][payload.theme][payload.reference][art].type_promo=''
            state.articles[payload.marque][payload.theme][payload.reference][art].prix_promo=''
          }
        }
      },
    getters:{},
    actions :{}
})
export default store